import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Alert } from '@dev/ee-components';
import { Link } from '@material-ui/core';
import { isReseller } from '@/services/Secuirty';
import { links } from '@/services/dictionaries/links';
import { getAccountStore } from '@/store/account/actions';
import { getTrackingDisabledInfo } from '@/components/Contacts/Geography/helpers';

import { AlertInfoInterface } from '@/components/Contacts/Geography/components/AlertInfo/AlertInfoInterface';

const AlertWrapper = styled.div`
    margin-bottom: 32px;
`;

export const AlertInfo: FC<AlertInfoInterface> = ({ campaign }: AlertInfoInterface): JSX.Element => {
    const { t } = useTranslation();
    const { AdvancedOptions } = useSelector(getAccountStore);
    const trackingDisabledInfo = getTrackingDisabledInfo(AdvancedOptions, campaign);
    if (!trackingDisabledInfo) {
        return null;
    }
    return (
        <AlertWrapper>
            <Alert
                severity="warning"
                body={
                    <div>
                        {trackingDisabledInfo}
                        {!isReseller() && (
                            <Link target="_blank" href={links.trackingOpensAndClicks}>
                                {t('learnmoreabouttracking')}
                            </Link>
                        )}
                    </div>
                }
            />
        </AlertWrapper>
    );
};
export default AlertInfo;
